import type { PatientInfo, ReportSectionData } from './types';

export const PATIENT_INFO_MDC: PatientInfo = {
  name: "Ms HUDA TAIMOR NAAMAN",
  dob: "14-07-1998",
  age: "26 Y",
  gender: "Female",
  referredBy: "SELF REQUEST",
  registrationNumber: "116286",
  requestNumber: "563984",
  requestedOn: "01-07-2025 / 10:47",
  collectedOn: "01-07-2025 / 10:53",
  reportedOn: "01-07-2025 / 12:40",
};

export const LAB_REPORT_DATA_MDC: ReportSectionData[] = [
  {
    title: "SEROLOGY",
    results: [
      { name: "Thyroid Peroxidase Antibodies (TPO)", value: "363.2 ↑", unit: "IU/mL", normalRange: "Up to 34.00" },
      { name: "Thyroglobulin (Tg)", value: "15.15", unit: "ng/mL", normalRange: "3.50 - 77.00" },
      { name: "Thyroglobulin Antibodies (Tg Ab)", value: "691.9 ↑", unit: "IU/mL", normalRange: "Up to 115.00" },
      { name: "Parathyroid Hormone (PTH)", value: "24.69", unit: "pg/mL", normalRange: "15.00 - 65.00" },
      { name: "Thyroid Stimulating Hormone Receptor Antibodies (Anti-TSHR)", value: "24.69", unit: "IU/L", normalRange: "Healthy individuals: < 1.22\nThyroid non-Graves' disease: 1.22 - 1.53\nGraves' disease: > 1.75" },
    ]
  },
  {
    title: "Basic Thyroid Function Tests",
    results: [
      { name: "Thyroid Stimulating Hormone (TSH)", value: "1.89", unit: "uIU/mL", normalRange: "0.27 - 4.20" },
      { name: "Free Triiodothyronine (FT3)", value: "3.83", unit: "pg/mL", normalRange: "2.00 - 4.40" },
      { name: "Free Thyroxine (FT4)", value: "1.09", unit: "ng/dL", normalRange: "0.92 - 1.68" },
    ]
  }
];
